export default {
  "content": "<path fill=\"#EFFAFD\" d=\"M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20z\"/><g clip-path=\"url(#clip0)\"><path fill=\"#028EB7\" d=\"M25.91 16.98c-.44-2.6-2.62-4.65-5.24-4.94A5.993 5.993 0 0014.81 21l4.15 6.42c.49.76 1.61.76 2.1 0L25.2 21h-.01c.67-1.15.97-2.55.72-4.02zM20 21c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z\"/></g><defs><clipPath id=\"clip0\"><path fill=\"#fff\" d=\"M0 0h12v15.99H0z\" transform=\"translate(14 12)\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "40",
    "height": "40",
    "fill": "none"
  }
};